import React from "react";
import { Button, Space, Modal } from "antd";
import {
  deleteConfirmMessage,
  activationConfirmMessage,
} from "../forms/formsFeedback";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

const Actions = (props) => {
  const {
    record,
    onFirstClicked,
    firstActionIcon,
    firstActionText,
    onSecondClicked,
    secondActionIcon,
    onActivateConfirmed,
    onDeleteConfirmed,
    dangerActionIcon,
    dangerActionText,
    firstLoading,
    firstActionType,
    activeId,
    category,
  } = props;
  const intl = useIntl();
  const [modal, contextHolder] = Modal.useModal();
  const onActivateClicked = (record) => {
    activationConfirmMessage(
      record,
      intl,
      !record.active,
      record.name,
      category,
      onActivateConfirmed,
      modal
    );
  };

  const onDangerClicked = (record) => {
    deleteConfirmMessage(
      intl,
      record.name,
      category,
      record.id,
      onDeleteConfirmed,
      modal
    );
  };

  return (
    <Space size="middle">
      {contextHolder}
      {onFirstClicked ? (
        <Button
          loading={
            activeId ? activeId === record.id && firstLoading : firstLoading
          }
          type={firstActionType ? firstActionType : "text"}
          onClick={() => {
            onFirstClicked(record);
          }}
          disabled={firstLoading}
        >
          {firstActionIcon
            ? firstActionIcon
            : intl.formatMessage({
                id: `app.actions.${firstActionText}`,
              })}
        </Button>
      ) : null}
      {onSecondClicked ? (
        <Button
          type="link"
          onClick={() => {
            onSecondClicked(record);
          }}
          disabled={firstLoading}
        >
          {secondActionIcon}
        </Button>
      ) : null}

      {onActivateConfirmed ? (
        <Button
          type="link"
          onClick={() => {
            onActivateClicked(record);
          }}
        >
          {record.active ? (
            <FormattedMessage id="app.actions.disable" />
          ) : (
            <FormattedMessage id="app.actions.activate" />
          )}
        </Button>
      ) : null}

      {onDeleteConfirmed ? (
        <Button
          danger
          type="text"
          onClick={() => {
            onDangerClicked(record);
          }}
          disabled={firstLoading}
        >
          {dangerActionIcon
            ? dangerActionIcon
            : intl.formatMessage({
                id: `app.actions.${dangerActionText}`,
              })}
        </Button>
      ) : null}
    </Space>
  );
};

export default Actions;
